import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { ActiveWoService } from '../../active-wo.service';

@Component({
  selector: 'app-active-wo',
  templateUrl: './active-wo.component.html',
  styleUrls: ['./active-wo.component.scss']
})
export class ActiveWoComponent implements OnInit {

  title = '';
  siteId = 0;
  woInfo = [];
  authInspectors = [];
  contacts = [];
  specifications = [];
  selectedWo = '';

  constructor(
    public dialogRef: MatDialogRef<ActiveWoComponent>,
    public activeWoService: ActiveWoService,
    @Inject(MAT_DIALOG_DATA) public info: any,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.siteId = this.info.siteId;
    this.title = 'Active WO\'s For ' + this.info.name;

    this.activeWoService.getActiveWos(this.siteId)
      .subscribe((woData) => {
        this.woInfo = woData;
        this.selectedWo = woData[0].wafNumber;
        this.getInfo();
      });
  }

  getInfo() {
    this.activeWoService.getSpecifications(this.selectedWo)
        .subscribe((specData) => {
          this.specifications = specData;
        });
    this.activeWoService.getContacts(this.selectedWo)
        .subscribe((ctcData) => {
          this.contacts = ctcData;
          for (const c of this.contacts) {
            c.formatCell = this.formatPhone(c.mobilePhone);
            c.formatOffice = this.formatPhone(c.officePhone);
          }
        });
    this.activeWoService.getAuthInsp(this.selectedWo)
        .subscribe((inspData) => {
          this.authInspectors = inspData;
        });
  }

  formatPhone(num: String) {
    return num.replace(/[-+()\s]/g, '');
  }

  changedWaf(waf: any) {
    this.getInfo();
  }

  closeDialog() {
    this.dialogRef.close({});
  }

}
